var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../public/assets/cwi_logo.png"),"height":"65"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }